const initialState = {
  height: null,
};

const Actions = {
  WIZARD_HEIGHT_CHANGED: 'wizard/height-changed',
};

const heightChanged = (height) => ({
  type: Actions.WIZARD_HEIGHT_CHANGED,
  height,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.WIZARD_HEIGHT_CHANGED:
      return { ...state, height: action.height };
  }

  return state;
};

const selectHeight = (state) => state.wizard.height;

export { reducer, heightChanged, selectHeight };
